export const HEARTBEAT_INTERVAL_MS = 30_000
export const HEARTBEAT_REQUEST_TIMEOUT_MS = 10_000

export function canHeartbeatRecoverConnection(status: unknown): boolean {
  return status === 'in_progress'
}
